module.exports = __webpack_public_path__ + "img/businessTwo.3a331dbd.svg";